import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { generateTraceId, generateSpanId } from '../utils/propagationContext.js';
import { TRACE_FLAG_NONE } from '../utils/spanUtils.js';

/**
 * A Sentry Span that is non-recording, meaning it will not be sent to Sentry.
 */
var SentryNonRecordingSpan = /*#__PURE__*/function () {
  function SentryNonRecordingSpan() {
    var spanContext = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, SentryNonRecordingSpan);
    this._traceId = spanContext.traceId || generateTraceId();
    this._spanId = spanContext.spanId || generateSpanId();
  }

  /** @inheritdoc */
  return _createClass(SentryNonRecordingSpan, [{
    key: "spanContext",
    value: function spanContext() {
      return {
        spanId: this._spanId,
        traceId: this._traceId,
        traceFlags: TRACE_FLAG_NONE
      };
    }

    /** @inheritdoc */
  }, {
    key: "end",
    value: function end(_timestamp) {}

    /** @inheritdoc */
  }, {
    key: "setAttribute",
    value: function setAttribute(_key, _value) {
      return this;
    }

    /** @inheritdoc */
  }, {
    key: "setAttributes",
    value: function setAttributes(_values) {
      return this;
    }

    /** @inheritdoc */
  }, {
    key: "setStatus",
    value: function setStatus(_status) {
      return this;
    }

    /** @inheritdoc */
  }, {
    key: "updateName",
    value: function updateName(_name) {
      return this;
    }

    /** @inheritdoc */
  }, {
    key: "isRecording",
    value: function isRecording() {
      return false;
    }

    /** @inheritdoc */
  }, {
    key: "addEvent",
    value: function addEvent(_name, _attributesOrStartTime, _startTime) {
      return this;
    }

    /** @inheritDoc */
  }, {
    key: "addLink",
    value: function addLink(_link) {
      return this;
    }

    /** @inheritDoc */
  }, {
    key: "addLinks",
    value: function addLinks(_links) {
      return this;
    }

    /**
     * This should generally not be used,
     * but we need it for being compliant with the OTEL Span interface.
     *
     * @hidden
     * @internal
     */
  }, {
    key: "recordException",
    value: function recordException(_exception, _time) {
      // noop
    }
  }]);
}();
export { SentryNonRecordingSpan };